import KybOTPForm from './KybOTP.Form';
import KybOTPHeader from './KybOTP.Header';

const KybOTP = () => (
	<div className='registerYourBusinessAuth_otp border-primary-500'>
		<KybOTPHeader />

		<KybOTPForm />
	</div>
);

export default KybOTP;
